<template>
  <div class="footer" ref="footer" id="home-footer">
    <div class="footer-top">
      <div class="content">
        <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" class="logo" />
        <p class="p2">{{activityDetail.name | dealLanguage(activityDetail.enName)}}</p>
        <!-- <p class="p2">{{'2025年9月12日至9月13日' | dealLanguage('SEP 12-13, 2025')}} &nbsp;&nbsp; {{'中国·北京' | dealLanguage('BEIJING·CHINA')}}</p> -->

        <div class="link" v-if="btnList.length">
          <div class="link-title">{{'快捷入口' | dealLanguage('QUICK ACCESS')}}</div>
          <div class="link-list">
            <div v-for="item,index in btnList" :key="index"><a @click="clickBanner(item, 'footer')">{{item.description}}</a></div>
          </div>
        </div>
        <div class="link">
          <div class="link-title">CSGCT</div>
          <div class="link-list link-list2">
            <div v-for="item,index in navPosition1" :key="index"><a @click="handleChangeRoute('contentPage' + item.id)">{{item.pageName | dealLanguage(item.enPageTitle)}}</a></div>
            <div><a @click="handleChangeRoute('guests')">{{'发言嘉宾' | dealLanguage('Guests')}}</a></div>
            <div><a @click="handleChangeRoute('newsList')">{{'新闻动态' | dealLanguage('NEWS')}}</a></div>
          </div>
        </div>

        <div class="link">
          <div class="link-title">{{'联系我们' | dealLanguage('CONTACT')}}</div>
          <div class="str">
            <p>{{'大会咨询请联系' | dealLanguage('For meeting inquiries, please contact: ')}}</p>
            <p>{{'何妮可' | dealLanguage('Nicole He')}}</p>
            <p>{{'邮箱：join@csgct.com.cn' | dealLanguage('Email: join@csgct.com.cn')}}</p>
          </div>
        </div>

        <!-- <div class="right">
          <div class="ewm-item">
            <p class="title">{{'联系我们' | dealLanguage('Contact Us')}}</p>
            <img :src="static_img_url + 'pic/xiaoqiang.png?v=' + $store.state.imgVersion" />
            <p class="p1">{{'动脉网-翁先生' | dealLanguage('VBEF-Mr.Weng')}}</p>
          </div>
          <div class="ewm-item">
            <p class="title">{{'关注我们' | dealLanguage('Follow Us')}}</p>
            <img :src="static_img_url + 'pic/vbef-code.png?v=' + $store.state.imgVersion" />
            <p class="p1">{{'VBEF订阅号' | dealLanguage('VBEF-Official Account')}}</p>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="footer-bottom">
      <a href="http://beian.miit.gov.cn" target="_blank">© 动脉橙 渝ICP备18013108号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165">
        <img :src="img_req_url + '/upload/vcbeat/public/images/pb-icon.png?v=' + $store.state.imgVersion" />
        渝公网安备 50011202502165号
      </a>
      <a href="javascript:void(0)" @click="certificate_model = true">互联网药品信息服务资格证书：（渝）-非经营性-2023-0083</a>
    </div>
    <Modal class="certificate-model" v-model="certificate_model" width="960" :footer-hide="true">
      <img :src="static_img_url + 'pic/certificate.jpg'" class="certificate-img" />
    </Modal> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  inject: ['clickBanner', 'globalInsertRecords'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      certificate_model: false,
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
      language: (state) => state.language,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
    }),
    navPosition1() {
      let arr = this.contentNav.filter((item) => [263].includes(item.id))
      return arr
    },
  },
  methods: {
    handleChangeRoute(name) {
      // 判断name是否包含contentPage
      if (name.indexOf('contentPage') > -1) {
        let content_id = name.split('contentPage')[1] - 0
        let index = this.contentNav.findIndex((item) => item.id == content_id)
        if (index > -1) {
          this.globalInsertRecords({
            contentId: content_id,
            contentType: 81,
            viewType: 1,
            keyword: this.contentNav[index].pageName,
          })
        }
        this.$router.push({ name: 'exhibitionDesc', params: { id: content_id } })
        return
      }
      let kw = ''
      switch (name) {
        case 'guests':
          kw = '发言嘉宾'
          break
        case 'newsList':
          kw = '新闻动态'
          break
      }
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="stylus" scoped>
.footer
  width 100%
  .footer-top
    margin 0 auto
    padding 0.4rem
    .content
      .logo
        display block
        width auto
        height 1.2rem
        font-size 0
        &+.p2
          margin-top 0.3rem
      .p2
        font-size 0.26rem
        color #333333
        line-height 0.36rem
        &+.p2
          margin-top 0.36rem
      .link
        margin-top 0.5rem
        .link-title
          font-size 0.3rem
          color #C8161D
          line-height 0.42rem
          font-weight 600
        .link-list2
          display flex
          flex-wrap wrap
          div
            flex 0 0 calc(50% - 10px)
            &:nth-child(odd)
              margin-right 20px
        .link-list
          div
            margin 0.2rem 0 0 0
          a
            white-space nowrap
            font-size 0.26rem
            color #333333
            line-height 0.36rem
        .str
          margin 0.2rem 0 0 0
          font-size 0.26rem
          color #333333
          line-height 0.42rem
      .right
        display flex
        justify-content space-between
        margin-top 0.47rem
        .ewm-item
          flex 0 0 2rem
          display flex
          flex-direction column
          align-items center
          position relative
          padding-top 0.6rem
          img
            width 2rem
            height 2rem
          .p1
            font-size 0.22rem
            color #6D6D6D
            line-height 0.31rem
            margin-top 0.1rem
            white-space nowrap
          .title
            position absolute
            font-size 0.3rem
            color #333333
            line-height 0.42rem
            font-weight 600
            left 0
            top 0
  .footer-bottom
    width 100%
    padding 0.16rem 0
    background #000
    text-align center
    display flex
    align-items center
    justify-content space-evenly
    flex-wrap wrap
    a
      font-size 0.22rem
      color #fff
      display flex
      align-items center
      margin 0.08rem
      img
        margin-right 0.04rem
        width 0.16rem
      &:active
        color #C8161D
.certificate-model
  >>> .ivu-modal-content
    border-radius 0
    .ivu-modal-close
      .ivu-icon-ios-close
        color #fff
    .ivu-modal-body
      padding 0
      font-size 0
.certificate-img
  width 100%
</style>
